module.exports = __webpack_public_path__ + "static/media/explore4.1a87e29e.jpg";